/**
 * This is an auto generated file - do not modify manually!
 * Fonts are fetched via Figma api
 */
var fontWeights = {
  light: 300,
  regular: 400,
  medium: 500,
  bold: 700,
  "default": 400
};
export { fontWeights };